<template>
  <div class="searchList">
    <div class="box-content">
      <label class="form-tit">订单编号</label>
      <el-input
        v-model="searchData.big_order_no"
        class="jm-input280"/>
    </div>
    <div class="box-content">
      <label class="form-tit">订单名称</label>
      <el-input
        v-model="searchData.title"
        class="jm-input280"/>
    </div>
    <div class="box-content">
      <label class="form-tit">APP用户ID</label>
      <el-input
        v-model="searchData.uid"
        class="jm-input280"/>
    </div>
    <div class="box-content">
      <label class="form-tit">APP用户名</label>
      <el-input
        v-model="searchData.account"
        class="jm-input280"/>
    </div>
    <div class="box-content">
      <label class="form-tit">学生编码</label>
      <el-input
        v-model="searchData.userid"
        class="jm-input280"/>
    </div>
    <div class="box-content">
      <label class="form-tit">学生姓名</label>
      <el-input
        v-model="searchData.username"
        class="jm-input280"/>
    </div>
    <div class="box-content">
      <label class="form-tit">电话号码</label>
      <el-input
        v-model="searchData.tel"
        class="jm-input280"/>
    </div>
    <div class="box-content">
      <label class="form-tit">创建时间</label>
      <el-date-picker
        class="jm-input280"
        v-model="searchData.create_time"
        type="daterange"
        value-format="yyyy-MM-dd"
        range-separator="-"
        start-placeholder="开始日期"
        end-placeholder="结束日期">
      </el-date-picker>
    </div>
  </div>
</template>
<script>
function initSearchData() {
  return {
    uid: '',
    account: '',
    tel: '',
    userid: '',
    username: '',
    title: '',
    big_order_no: '',
    create_time: [],
    site_name: 'nseries'
  };
}
export default {
  props: {
    searchData: {
      type: Object,
      default: initSearchData(),
    },
  },
  data() {
    return {
      classes: [],
      pageDs: {}
    };
  },
  methods: {
    initSearchData() {
      return initSearchData();
    }
  },
  components: {},
  mounted() {},
  watch: {
    searchData: {
      handler: function (newValue) {
        this.$emit('update:searchData', newValue);
      },
      deep: true
    }
  }
};
</script>
